import { dispatchSnackbarWarningEvent } from '@dreryk/react-components';

import { translationKeys } from '../translations';

export const ensureMicrophoneAccess = async (): Promise<boolean> => {
   try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      stream.getTracks().forEach((track) => track.stop());
      return true;
   } catch {
      dispatchSnackbarWarningEvent(translationKeys.faults.microphoneAccessDenied);
      return false;
   }
};
